import { cn } from '@wundo/ui';

export interface PracticeObjectiveListProps {
  objectives: string[];
  className?: string;
}

/** What the user is practising, one dotted line each. */
export function PracticeObjectiveList({
  objectives,
  className,
}: PracticeObjectiveListProps) {
  return (
    <ul className={cn('flex flex-col gap-2.25', className)}>
      {objectives.map((objective) => (
        <li key={objective} className='flex items-start gap-2.25'>
          <span
            aria-hidden='true'
            className='mt-2 size-1.5 shrink-0 rounded-full bg-accent'
          />
          <span className='text-md text-ink-body'>{objective}</span>
        </li>
      ))}
    </ul>
  );
}
